import root from "./_root.js";
var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports, freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module, moduleExports = freeModule && freeModule.exports === freeExports, Buffer = moduleExports ? root.Buffer : void 0;
Buffer && Buffer.allocUnsafe;
function cloneBuffer(buffer, isDeep) {
  return buffer.slice();
}
export {
  cloneBuffer as default
};
//# sourceMappingURL=_cloneBuffer.js.map
